module.exports = __webpack_public_path__ + "img/InvitaYgana_title.70219343.png";